// types/SingleNode.ts
import type { StrategyNode } from "./BaseNode";
import { v4 as uuid } from 'uuid';

export type SingleConfig = {
  typeId: string;                 // e.g. "trade_vwap", "linepack"
  props: Record<string, any>;     // dynamic fields from /data_types (e.g. { hub: 3, start: "2025-08-01" })
};

export class SingleNode implements StrategyNode {
  id: string;
  type: 'Single' = 'Single';
  title?: string;
  isManualRename?: boolean;
  config: SingleConfig;

  constructor(id: string, title?: string, isManualRename?: boolean, config?: SingleConfig) {
    this.id = id;
    this.title = title;
    this.isManualRename = isManualRename;
    this.config = config || { typeId: "", props: {} };
  }

  update(id: string, patch: Partial<StrategyNode>): StrategyNode {
    if (this.id !== id) return this;

    const incomingConfig = (patch as any)?.config || {};
    const newTypeId = incomingConfig.typeId ?? this.config.typeId ?? "";
    const typeChanged = newTypeId !== this.config.typeId;

    const newConfig: SingleConfig = {
      typeId: newTypeId,
      props: typeChanged 
        ? (incomingConfig.props || {}) // Reset props if type changed
        : { ...(this.config.props || {}), ...(incomingConfig.props || {}) } // Merge if same type
    };

    return new SingleNode(this.id, patch.title ?? this.title, patch.isManualRename ?? this.isManualRename, newConfig);
  }

  clone(): StrategyNode {
    const copy = new SingleNode(uuid(), this.title, this.isManualRename);
    copy.config = {
      typeId: this.config.typeId,
      props: { ...this.config.props }
    };
    return copy;
  }
}
